function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 14.97c0-.76-.3-1.51-.88-2.1l-3-3a3 3 0 00-4.24 0l-3 3A3 3 0 006 15a4 4 0 01-.99-7.88 5.5 5.5 0 0110.86-.82A4.49 4.49 0 0122 10.5a4.5 4.5 0 01-4 4.47z",
  fill: "#ACE1FF"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 14.41V21a1 1 0 102 0v-6.59l1.3 1.3a1 1 0 001.4-1.42l-3-3a1 1 0 00-1.4 0l-3 3a1 1 0 001.4 1.42l1.3-1.3z",
  fill: "#000"
});

var SvgCloudUpload = function SvgCloudUpload(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCloudUpload;